<template>
  <div id="participant-add-update">
    <el-row :gutter="10" class="mt-3 ">
      <el-col :span="24">
        <el-collapse accordion>
          <el-collapse-item name="2">
            <template slot="title"> {{$t('components.participantAddOrUpdate.auths')}} </template>
            <el-row :gutter="10">
              <el-col :span="24">
                <div>{{$t('components.participantAddOrUpdate.authsMsg')}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="mt-3">
              <el-col :span="24">
                <div class="add-manager-container">
                  <div class="add-manager-title">
                    <div class="add-m-title">
                      {{$t('components.participantAddOrUpdate.addAuth')}}
                    </div>
                    <div class="add-m-input">
                      <el-select v-model="lastParticiId" clearable @clear="lastParticiId = null" :placeholder="$t('components.participantAddOrUpdate.placeholderSelectAuth')">
                        <el-option v-for="(item, index) in getParticipantsItems" :key="index" :label="item.firstName + ' ' + item.lastName" :value="item.id"> </el-option>
                      </el-select>
                    </div>
                    <div class="add-m-btn">
                      <el-button round size="small" type="primary" @click="addManager">{{$t('components.participantAddOrUpdate.add')}}</el-button>
                    </div>
                  </div>
                  <template v-if="form.managers.length > 0">
                    <div class="area-maps-title">
                      <div></div>
                      <div>{{$t('components.participantAddOrUpdate.speaker')}}</div>
                      <div>{{$t('components.participantAddOrUpdate.task')}}</div>
                      <div>{{$t('components.participantAddOrUpdate.show')}}</div>
                      <div></div>
                    </div>
                    <draggable :list="form.managers" tag="div" handle=".el-icon-s-grid" class="list-group-o participant-add-container" v-bind="dragOptions" @start="dragList = true" @end="dragList = false">
                      <div class="item" v-for="(item, index) in form.managers" :key="index" :class="{ passive: !item.isActive }">
                        <div class="table-icon">
                          <i class="el-icon-s-grid burger"></i>
                        </div>
                        <div class="img-title">
                          <div class="img-title-alt">
                            <div class="networking-title">
                              <div>#{{ item.participant.participantNO }}</div>
                              {{ item.participant.fullName }}
                              <div class="color-title">
                                <div class="circle-color-pick" :style="{ 'background-color': $store.state.tags.items.find((x) => x.id == item.participant.tagID).color }"></div>
                                {{ $store.state.tags.items.find((x) => x.id == item.participant.tagID).title }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <el-select v-model="item.type" v-if="getEnums">
                            <el-option v-for="(option, index) in getEnums.find((x) => x.title == 'NetworkingAreaManagerType').enums" :label="option.displayName" :value="option.key" :key="index"></el-option>
                          </el-select>
                        </div>
                        <div><el-switch v-model="item.isActive"></el-switch></div>
                        <div style="display:flex; flex-direction:row;gap:.5rem">
                          <el-button type="danger" icon="fas fa-trash" size="mini" circle @click="form.managers.splice(index, 1)"></el-button>
                        </div>
                      </div>
                    </draggable>
                  </template>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title"> {{$t('components.participantAddOrUpdate.settings')}} </template>
            <el-row :gutter="10">
              <el-col :span="24">
                <div>{{$t('components.participantAddOrUpdate.settingsMsg')}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="mt-3">
              <el-col :span="24">
                <div class="registerform-input-container">
                  <div class="title">
                    <div class="title-container">
                      <label>{{$t('components.participantAddOrUpdate.show')}}</label>
                      <el-tooltip content="Content" placement="bottom">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                    <el-switch v-model="form.isActive"> </el-switch>
                  </div>
                  <div class="text-field">{{$t('components.participantAddOrUpdate.showMsg')}}</div>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item name="4" v-if="form.id != null">
            <template slot="title"> {{$t('components.participantAddOrUpdate.accessControl')}} </template>
            <el-row :gutter="10">
              <el-col :span="24">
                <div>{{$t('components.participantAddOrUpdate.accessControlMsg')}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="mt-3">
              <el-col :span="24">
                <!-- TODO - ICON DEGİŞİCEK  -->
                <div class="control-point-info">
                  <div class="container-info">
                    <div class="qr-img">
                      <i class="el-icon-menu"></i>
                    </div>
                    <div class="title">
                      {{$t('components.participantAddOrUpdate.noController')}}
                      <el-button round type="primary" size="mini">{{$t('components.participantAddOrUpdate.goControlCenter')}}</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          
        </el-collapse>
      </el-col>
    </el-row>

    <!-- <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px">
              <div class="card-body">
                <input
                  autocomplete="false"
                  name="hidden"
                  type="text"
                  style="display: none"
                />

                <el-radio-group v-model="activeName">
                  <el-radio-button :label="null">{{
                    this.$t("event.components.query.normal")
                  }}</el-radio-button>
                  <el-radio-button
                    :label="item"
                    v-for="(item, index) in $store.state.packets.items.filter(
                      (x) => x.isActive
                    )"
                    :key="index"
                    >{{ item.title }}</el-radio-button
                  >
                </el-radio-group>

                <div class="row">
                  <div class="col-md-12">
                    <div class="row mt-3">
                      <div class="form-group col-md-4">
                        <label>
                          {{ this.$t("event.table.firstname") }}
                          <span class="text-danger">*</span>
                        </label>
                        <el-input
                          :placeholder="$t('exp.participant_')"
                          v-model="form.firstName"
                          :class="$inputError('firstName', validationErrors)"
                        ></el-input>
                        <span class="error">
                          {{ $errorMessage("firstName", validationErrors) }}
                        </span>
                      </div>

                      <div class="form-group col-md-4">
                        <label>
                          {{ this.$t("event.table.lastname") }}
                          <span class="text-danger">*</span>
                        </label>
                        <el-input
                          :placeholder="$t('exp.participant')"
                          v-model="form.lastName"
                          :class="$inputError('lastName', validationErrors)"
                        ></el-input>
                        <span class="error">
                          {{ $errorMessage("lastName", validationErrors) }}
                        </span>
                      </div>

                      <div class="form-group col-md-4">
                        <label>
                          {{ this.$t("event.filter.tag") }}
                          <span class="text-danger">*</span>
                        </label>
                        <el-select
                          v-model="form.tagID"
                          :placeholder="$t('event.textbox.select')"
                          :disabled="controlTag"
                          :class="$inputError('tagID', validationErrors)"
                          clearable
                        >
                          <el-option
                            v-for="item in $store.state.tags.items"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id"
                            clearable
                          ></el-option>
                        </el-select>
                        <span class="error">
                          {{ $errorMessage("tagID", validationErrors) }}
                        </span>
                      </div>

                      <div
                        class="form-group col-md-4"
                        v-if="
                          activeName != null &&
                          activeName.dayRestrictions.length != 0
                        "
                      >
                        <label>
                          {{ this.$t("event.components.query.dayRest") }}
                          <span class="text-danger">*</span>
                        </label>
                        <el-select
                          v-model="form.dayRestrictions"
                          :placeholder="$t('event.textbox.select')"
                          multiple
                          clearable
                          :class="
                            $inputError('dayRestriction', validationErrors)
                          "
                        >
                          <el-option
                            v-for="day in activeName.dayRestrictions"
                            :key="day.date"
                            :label="$moment(day.date).format('DD MMMM YYYY')"
                            :value="day.date"
                          ></el-option>
                        </el-select>

                        <span class="error">
                          {{
                            $errorMessage("dayRestriction", validationErrors)
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="mb-2" v-if="filteredInputs.length != 0">
                      <h5>{{this.$t('event.components.query.titleOthers')}}</h5>
                      <span>
                        <template v-if="$i18n.locale == 'tr'">
                          Zorunlu alanlar
                          <code>*</code> yıldız ile belirtilmiştir.
                        </template>

                        <template v-else>
                          Mandatory fields are marked with
                          <code>*</code>
                        </template>
                      </span>
                    </div>

                    <div class="row">
                      <template v-for="(item, index) in filteredInputs">
                        <div
                          class="form-group col-md-4"
                          v-if="
                            item.input.type == 1 ||
                            item.input.type == 3 ||
                            item.input.type == 4 ||
                            item.input.type == 5 ||
                            item.input.type == 6 ||
                            item.input.type == 8 ||
                            item.input.type == 9 ||
                            item.input.type == 20 ||
                            item.input.type == 21 ||
                            item.input.type == 22 ||
                            item.input.type == 24 ||
                            item.input.type == 25 ||
                            item.input.type == 10 ||
                            item.input.type == 12
                          "
                          :key="item.input.id"
                        >
                          <label>
                            {{ item.input.title }}
                            <span
                              class="text-danger"
                              v-if="item.input.isRequired"
                              >*</span
                            >
                          </label>

                          <el-input
                            placeholder="..."
                            v-model="filteredInputs[index].answer"
                            :class="
                              $inputError(item.input.id, validationErrors)
                            "
                          ></el-input>
                          <span class="error">
                            {{ $errorMessage(item.input.id, validationErrors) }}
                          </span>
                        </div>

                        <div
                          class="form-group col-md-4"
                          v-if="item.input.type == 11"
                          :key="item.input.id"
                        >
                          <label>
                            {{ item.input.title }}
                            <span
                              class="text-danger"
                              v-if="item.input.isRequired"
                              >*</span
                            >
                          </label>

                          <el-input
                            placeholder="..."
                            type="textarea"
                            v-model="filteredInputs[index].answer"
                            :class="
                              $inputError(item.input.id, validationErrors)
                            "
                          ></el-input>
                          <span class="error">
                            {{ $errorMessage(item.input.id, validationErrors) }}
                          </span>
                        </div>

                        <div
                          class="form-group col-md-4"
                          v-if="item.input.type == 14"
                          :key="item.input.id"
                        >
                          <label>
                            {{ item.input.title }}
                            <span
                              class="text-danger"
                              v-if="item.input.isRequired"
                              >*</span
                            >
                          </label>

                          <el-input-number
                            v-model="filteredInputs[index].answer"
                            style="width: 100%"
                            :class="
                              $inputError(item.input.id, validationErrors)
                            "
                          ></el-input-number>
                          <span class="error">
                            {{ $errorMessage(item.input.id, validationErrors) }}
                          </span>
                        </div>

                        <div
                          class="form-group col-md-4"
                          v-if="item.input.type == 15"
                          :key="item.input.id"
                        >
                          <label>
                            {{ item.input.title }}
                            <span
                              class="text-danger"
                              v-if="item.input.isRequired"
                              >*</span
                            >
                          </label>

                          <el-select
                            v-model="filteredInputs[index].answer"
                            :placeholder="$t('event.textbox.select')"
                            clearable
                            :class="
                              $inputError(item.input.id, validationErrors)
                            "
                          >
                            <el-option
                              v-for="answer in item.input.answers"
                              :key="answer"
                              :label="answer"
                              :value="answer"
                            ></el-option>
                          </el-select>

                          <span class="error">
                            {{ $errorMessage(item.input.id, validationErrors) }}
                          </span>
                        </div>

                        <div
                          class="form-group col-md-4"
                          v-if="item.input.type == 16"
                          :key="item.input.id"
                        >
                          <label>
                            {{ item.input.title }}
                            <span
                              class="text-danger"
                              v-if="item.input.isRequired"
                              >*</span
                            >
                          </label>

                          <el-select
                            v-model="filteredInputs[index].answers"
                            :placeholder="$t('event.textbox.select')"
                            clearable
                            multiple
                            :class="
                              $inputError(item.input.id, validationErrors)
                            "
                          >
                            <el-option
                              v-for="answer in item.input.answers"
                              :key="answer"
                              :label="answer"
                              :value="answer"
                            ></el-option>
                          </el-select>

                          <span class="error">
                            {{ $errorMessage(item.input.id, validationErrors) }}
                          </span>
                        </div>

                        <div
                          class="form-group col-md-4"
                          v-if="item.input.type == 23"
                          :key="item.input.id"
                        >
                          <label>
                            {{ item.input.title }}
                            <span
                              class="text-danger"
                              v-if="item.input.isRequired"
                              >*</span
                            >
                          </label>

                          <el-date-picker :format="datePickerDisplayFormat()" 
                            type="date"
                            format="dd.MM.yyyy"
                            v-model="filteredInputs[index].answer"
                          ></el-date-picker>

                          <span class="error">
                            {{ $errorMessage(item.input.id, validationErrors) }}
                          </span>
                        </div>

                        <div
                          class="form-group col-md-4"
                          v-if="item.input.type == 7"
                          :key="item.input.id"
                        >
                          <label>
                            {{ item.input.title }}
                            <span
                              class="text-danger"
                              v-if="item.input.isRequired"
                              >*</span
                            >
                          </label>

                          <el-select
                            v-model="filteredInputs[index].answer"
                            :placeholder="$t('event.textbox.select')"
                            clearable
                            :class="
                              $inputError(item.input.id, validationErrors)
                            "
                          >
                            <el-option
                              :label="$t('options.female')"
                              :value="$t('options.female')"
                            ></el-option>
                            <el-option
                              :label="$t('options.male')"
                              :value="$t('options.male')"
                            ></el-option>
                            <el-option
                              :label="$t('options.other')"
                              :value="$t('options.other')"
                            ></el-option>
                          </el-select>

                          <span class="error">
                            {{ $errorMessage(item.input.id, validationErrors) }}
                          </span>
                        </div>

                        <div
                          class="form-group col-md-4"
                          v-if="item.input.type == 2 || item.input.type == 13"
                          :key="item.input.id"
                        >
                          <label>
                            {{ item.input.title }}
                            <span
                              class="text-danger"
                              v-if="item.input.isRequired"
                              >*</span
                            >
                          </label>

                          <vue-tel-input
                            class="el-input__inner"
                            mode="international"
                            :placeholder="$t('enterPhone')"
                            :enabledCountryCode="true"
                            v-model="filteredInputs[index].answer"
                          ></vue-tel-input>

                          <span class="error">
                            {{ $errorMessage(item.input.id, validationErrors) }}
                          </span>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0;
                  "
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button
                        slot="reference"
                        type="danger"
                        icon="fas fa-trash"
                        >{{ $t("event.table.delete") }}</el-button
                      >
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="
                      display: flex;
                      flex: 1;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                        >{{ $t("event.buttons.close") }}</el-button
                      >
                      <el-button type="success" @click="save">{{
                        $t("event.buttons.save")
                      }}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 10px 0px;
      "
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo },
  name: "ParticipantAddUpdate",
  props: ["data"],
  data() {
    return {
      originalTagID: null,
      activeName: null,
      filteredInputs: [],
      form: {
        id: null,
        firstName: null,
        lastName: null,
        tagID: null,
        dayRestrictions: [],
        registrationInputs: [],
      },
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
    };
  },
  methods: {
    deleteItem() {
      var index = this.$store.state.participants.items.findIndex(
        (k) => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      this.validationErrors = [];

      var req = this.form;

      var d = JSON.parse(JSON.stringify(this.filteredInputs));

      d.map((x, index) => {
        if (x.answer != null) {
          d[index].answer = x.answer.toString();
        }
        if (x.input.type == 2 || x.input.type == 13) {
          if (d[index].answer != null)
            d[index].answer = d[index].answer.split(" ").join("");
        }
        if (x.input.type == 16) {
          d[index].answer = x.answers.join(",");
        }
        if (x.input.type == 23) {
          if (d[index].answer != null)
            d[index].answer = x.answer.replace("T21", "T15");
        }
      });

      req = JSON.parse(JSON.stringify(req));

      axios
        .post("participant/addorupdate", {
          ...req,
          registrationInputs: d,
          packetID: this.activeName != null ? this.activeName.id : null,
        })
        .then((res) => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            if (this.form.id == null) {
              this.$emit("itemAdded");
              this.form = {
                id: null,
                firstName: null,
                lastName: null,
                tagID: null,
                dayRestrictions: [],
                registrationInputs: [],
              };

              this.$store.state.participants.registrationInputs.map((x) => {
                if (x.isActive) {
                  this.form.registrationInputs.push({
                    id: null,
                    registrationInputID: x.id,
                    answer: null,
                    input: x,
                    answers: [],
                  });
                }
              });

              this.getinputs();
            } else {
              this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
              if (this.showInfo) {
                this.showInfo = false;
                setTimeout(() => {
                  this.showInfo = true;
                }, 350);
              }
            }
          }
        });
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data;
      }
    },
    // getinputs() {
    //   if (this.activeName == null) {
    //     this.filteredInputs = this.form.registrationInputs.filter(
    //       (x) => x.input.packetIDs.length == 0
    //     );
    //   } else {
    //     this.filteredInputs = this.form.registrationInputs.filter(
    //       (x) =>
    //         x.input.packetIDs.some((y) => y == this.activeName.id) ||
    //         x.input.packetIDs.length == 0
    //     );
    //   }
    // },
  },
  mounted() {
    if (this.form.packetID == null) {
      this.activeName = null;
    } else {
      this.activeName = this.$store.state.packets.items.find(
        (x) => x.id == this.form.packetID
      );
      debugger;
    }
  },
  watch: {
    activeName: function (newVal) {
      if (newVal == null) {
        this.form.tagID = this.originalTagID;
      }
      this.getinputs();
      this.validationErrors = [];
    },
    data: function (newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        var a = [];
        this.$store.state.participants.registrationInputs.map((x) => {
          if (x.isActive) {
            a.push({
              id: null,
              registrationInputID: x.id,
              answer: this.data.registrationInputs.some(
                (t) => t.registrationInputID == x.id
              )
                ? this.data.registrationInputs.find(
                    (t) => t.registrationInputID == x.id
                  ).answer
                : null,
              input: x,
            });
          }
        });
        this.data.registrationInputs = a;
        this.form = this.data;
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          firstName: null,
          lastName: null,
          tagID: null,
          dayRestrictions: [],
          registrationInputs: [],
        };
      }

      this.getinputs();

      if (this.form.packetID == null) {
        this.activeName = null;
      } else {
        this.activeName = this.$store.state.packets.items.find(
          (x) => x.id == this.form.packetID
        );
      }
    },
  },
  async created() {
    if (this.data != undefined && this.data != null) {
      var x = JSON.parse(JSON.stringify(this.data));
      this.originalTagID = x.tagID;

      var a = [];
      this.$store.state.participants.registrationInputs.map((x) => {
        if (x.isActive) {
          a.push({
            id: null,
            registrationInputID: x.id,
            answer: this.data.registrationInputs.some(
              (t) => t.registrationInputID == x.id
            )
              ? this.data.registrationInputs.find(
                  (t) => t.registrationInputID == x.id
                ).answer
              : null,
            input: x,
            answers:
              x.type == 16
                ? this.data.registrationInputs.some(
                    (t) => t.registrationInputID == x.id
                  ) &&
                  this.data.registrationInputs.find(
                    (t) => t.registrationInputID == x.id
                  ).answer != null
                  ? this.data.registrationInputs
                      .find((t) => t.registrationInputID == x.id)
                      .answer.split(",")
                  : []
                : [],
          });
        }
      });
      this.data.registrationInputs = a;
      this.form = this.data;
      if (this.form.packetID == null) {
        this.activeName = null;
      } else {
        this.activeName = this.$store.state.packets.items.find(
          (x) => x.id == this.form.packetID
        );
      }
    } else {
      this.$store.state.participants.registrationInputs.map((x) => {
        if (x.isActive) {
          this.form.registrationInputs.push({
            id: null,
            registrationInputID: x.id,
            answer: null,
            answers: [],
            input: x,
          });
        }
      });
    }

    this.getinputs();
  },
  computed: {
    allForm(){

    },
    controlTag() {
      //this.form.dayRestrictions = [];
      if (this.activeName != null) {
        this.form.tagID = this.$store.state.packets.items.find(
          (x) => x.id == this.activeName.id
        ).tagID;
        return true;
      } else {
        if (this.form.id == null) {
          this.form.tagID = null;
        }
        return false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
#networking-add-new-update {
  padding: 1rem;
}
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.control-point-info {
  padding: 1rem 2rem;
  .container-info {
    background-color: #eaeaea;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    border-radius: 8px;
    .qr-img {
      i {
        font-size: 40px;
      }
    }
    .title {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .el-button {
        width: 150px;
        font-weight: 600;
      }
    }
  }
}
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.add-manager-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .add-manager-title {
    padding: 1rem;
    background-color: #f3f3f3;
    flex-direction: row;
    display: flex;
    gap: 1rem;
    align-items: center;
    .add-m-title {
      font-weight: bold;
    }
    .add-m-title,
    .add-m-btn {
      flex-shrink: 0;
    }
    .add-m-input {
      width: 100%;
    }
  }
}
.area-maps-title {
  display: grid;
  grid-template-columns: 1fr 8fr 6fr 2fr 1fr;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.participant-add-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 1fr 8fr 6fr 2fr 1fr;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ParticipantAddOrUpdate.vue